module.exports = __webpack_public_path__ + "img/undraw_No_data_re_kwbl.879f7550.png";